import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a06f79af6558f00146fc932/linearvh/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a06f79af6558f00146fc932/linearvh/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a06f79af6558f00146fc932/linearvh/src/components/Version3Popup.tsx");
